import { TakePicture } from '~/components';
import { MaskType } from '~/utils';

const OnboardingDocPhotoBack = ({
  handleSubmit,
}: {
  handleSubmit: (image: string) => Promise<void>;
}) => {
  return (
    <TakePicture
      handleSubmit={handleSubmit}
      allowFrontCamera={false}
      sceneTitle="Verso do documento"
      maskType={MaskType.DOCUMENT}
    />
  );
};

export default OnboardingDocPhotoBack;
